module.exports = __webpack_public_path__ + "static/media/Illus-Dressing_2.4d70ef45.png";